module.exports = __webpack_public_path__ + "static/media/wmTrial-words-2.5320e165.mp3";